import React from "react";
import PropTypes from "prop-types";
import classNames from "../../../utils/classNames";
import "./index.scss";

/* The cross is drawn, not typed. A text "×" is centred by the flex container as
   a LINE BOX, and the glyph's ink is not centred within its own line box — it
   sits on the font's math axis, which on this stack put it 5.4% of the button's
   diameter below centre. That offset belongs to the font, so nudging it up by a
   measured amount would drift the moment the font stack changed.
   Two lines crossing at the middle of the viewBox cannot be off-centre.

   Sized in `em` so every consumer's existing `--close-button-font-size` still
   controls it. The endpoints are set so the inked bbox — the 42-unit diagonal
   plus a round cap's radius at each end — lands at 0.485em, matching the ink
   the text glyph measured at the same font-size, so no button changes size. */
const CloseGlyph = () => (
  <svg
    className="close-button__glyph"
    viewBox="0 0 100 100"
    aria-hidden="true"
    focusable="false"
  >
    <line x1="29" y1="29" x2="71" y2="71" />
    <line x1="71" y1="29" x2="29" y2="71" />
  </svg>
);

const CloseButton = ({
  onClick = undefined,
  ariaLabel,
  className = "",
  children = null,
  ...props
}) => (
  <button
    type="button"
    className={classNames("close-button", className)}
    onClick={onClick}
    aria-label={ariaLabel}
    {...props}
  >
    <span className="close-button__content" aria-hidden="true">
      {children == null ? <CloseGlyph /> : children}
    </span>
  </button>
);

CloseButton.propTypes = {
  onClick: PropTypes.func,
  ariaLabel: PropTypes.string.isRequired,
  className: PropTypes.string,
  children: PropTypes.node,
};

export default CloseButton;
